import Axios from 'axios';
import {GetAPIURL} from '../URL/index';
import { config } from 'aws-sdk';

const AxiosInstance = Axios.create({
    baseURL: GetAPIURL(),
});

let currentUser = null;

export const setAxiosUser = (user) => {
    currentUser = user
}

AxiosInstance.interceptors.request.use(
    (config) => {

        if(currentUser?.userName) {
            config.headers['X-User'] = currentUser.username;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default AxiosInstance;